/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Type_PropertyInputs */

const cs_gdpr_type_property = /** @type {(inputs: Gdpr_Type_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost`)
};

const en_gdpr_type_property = /** @type {(inputs: Gdpr_Type_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property`)
};

/**
* | output |
* | --- |
* | "Property" |
*
* @param {Gdpr_Type_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_type_property = /** @type {((inputs?: Gdpr_Type_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Type_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_type_property(inputs)
	return cs_gdpr_type_property(inputs)
});